import { WOLFE_URL } from './endpoints';

export const FOOTER_LINKS = [
    {
        text: 'footer-the-company',
        link: WOLFE_URL + '/about-us',
    },
    {
        text: 'footer-partner-with-us',
        link: WOLFE_URL + '/partner-with-us',
    },
    {
        text: 'footer-faq',
        link: WOLFE_URL + '/faq',
    },
    {
        text: 'footer-terms-and-conditions',
        link: WOLFE_URL + '/terms-and-conditions',
    },
    {
        text: 'footer-refer-a-friend',
        link: WOLFE_URL + '/refer-a-friend',
    },
    {
        text: 'footer-contact-us',
        link: WOLFE_URL + '/contact-us',
    },
];
